import React, { useEffect, useState, useRef } from 'react'
import { Link, useNavigate, useParams } from 'react-router'
// import { Link } from 'react-router-dom'
// import Header from '../../components/Header';
// import { Formik } from 'formik';
// import fetchData from '../../api/FetchData';
import axios from 'axios'
import {
    Avatar,
    Box, 
    Button,
    Checkbox,
    Fab,
    FormControl,
    FormControlLabel,
    IconButton,
    Input,
    InputAdornment,
    InputBase,
    InputLabel,
    TextField,
    Typography,
    useMediaQuery,Tooltip,
    CircularProgress,
  } from '@mui/material';
  import { Close, Check, Save, Send, Visibility, VisibilityOff } from '@mui/icons-material';
  import ErrorOutlinedIcon from '@mui/icons-material/ErrorOutlined';
  import LockResetIcon from '@mui/icons-material/LockReset';
  import { enCrypt, deCrypt, aesEncrypt } from '../../api/enCrypt'
  // import { useSnackbar } from 'notistack';
  // import { useDispatch, useSelector } from 'react-redux'
  // import { getCurrentUser, setUser, setClearUser } from '../../context/userSlice'
  import CloudUploadIcon from '@mui/icons-material/CloudUpload';
  import CloudDoneIcon from '@mui/icons-material/CloudDone';
  import PersonAddAlt1Icon from '@mui/icons-material/PersonAddAlt1';
  import FolderSharedIcon from '@mui/icons-material/FolderShared';
  import { useUserContext, useUserDispatch } from '../../contexts/UserContext';
  import { PhotoIcon, UserCircleIcon } from '@heroicons/react/24/solid';
  import { ChevronDownIcon, PencilIcon  } from '@heroicons/react/16/solid';
  import MessInfo from '../../components/messInfo';
  import Autocomplete from '@mui/material/Autocomplete';


  const initValuesf = 
    {
      id: '',
      name:'',
      category:  '',
      description: '',
      img:  'noimg.png',
      instock:  0,
      price: 0,
      recommend: 0,
      promote: 0,
      active: 1,
    }
  

const ProductDetail = () => {
  const [loading, setLoading] = useState(false);
  const [errMsg, setErrMsg] = useState({type:'', info:''});
  const [dataChenged, setDataChenged] = useState(false);
  const [saveSuccess, setSaveSuccess] = useState(false);
  var dummy = 0
  const [showPassword, setShowPassword] = useState(false);
  const [chgpwd, setChgpwd] = useState(false);
  const [saveloading, setSaveLoading] = useState(false);
  const [filename, setFilename] = useState(null);
  const [file, setFile] = useState(null);
  const [uploading, setUploading] = useState(false);
  const [location, setLocation] = useState({ id: '', Image: '', Filename: '' });

  // const { enqueueSnackbar } = useSnackbar();
  // const { Users } = useSelector(getCurrentUser);
  const {productid} = useParams();
  const navigate = useNavigate();
  const user = useUserContext();
  const dispatch = useUserDispatch();
  const [category, setCategory] = useState([])

  // const Conf = JSON.parse(localStorage.getItem("Conf"));
  // const currentUser = JSON.parse(localStorage.getItem("currentUser"));
  // const currentUser = user;
  // console.log(userid)
  // console.log(user);
  const [valuesf, setValuesf] = useState(initValuesf)

  const apiurl = `${process.env.REACT_APP_API}`
  const imgurl = `${process.env.REACT_APP_URL}`

  // console.log(apiurl)

const fetchCategory = async () => {
    try {
      const result = await axios.get(`${apiurl}/products.php?mode=getcategory`);
      
      // console.log(result);
      // console.log(result.data);
      // if(result.data.length>0) {
      if(result.data && result.data[0].length>0) {  
        // const data = await response.json();
        // console.log(result.data[0]);
        setCategory(result.data[0]);
        return result.data[0];
      }

    }
    catch(err) {
        console.log(err);
      }
    }
  
useEffect(() => {

  fetchCategory();
  
},[])

  const fetchProduct = async (id) => {
    try {

      const response = await axios.get(`${apiurl}/products.php?mode=get&id=${id}`);
        
           const data = response.data;
            //  console.log(data);
            //  console.log(response);

      // if(data.length>0 && Object.keys(data).length !== 0) {
        if(data.message==="OK" && data[0].length>0) {
          // const data = await response.json();
          // console.log(data[0][0]);
          // setUsers(response.data[0]);
          setValuesf(data[0][0])
          return data;
    
      }else {
        console.log(response);
      }
    } catch (error) {
      console.error("Error fetching users:", error);

    }
  };

  // console.log(user);

  useEffect(() => {
    {!user.isLogin && navigate("/")}

    if(productid && productid!=='addnew') {
      fetchProduct(productid);  
    } else {
      setValuesf( initValuesf)
    }
  }, [productid,user])
    
  // console.log(valuesf);
  // console.log(conf)

  //===================== handle ================

  const handleAddnew = () => {
    // // dispatch(setClearUser())
    //   setDataChenged(false)
    //   setValuesf( {
    //     id: null,
    //     email:null,
    //     name:  null,
    //     password: null,
    //     Avatar:  'user.png',
    //     Role:  'User',
    //     isAdmin: false,
    //     actived:  false,
    //     }
    // )

    // setFilename('user.png')
      // console.log(Users)
      // console.log('handleAddnew')
      // console.log(valuesf)
      navigate('/products/addnew')
  }


  const onChangeFile = (e) => {
    e.preventDefault();
    // console.log(e.target.files[0]);
    setFile(e.target.files[0]);
    setFilename(e.target.files[0].name);
    // setDataChenged(true)
    
    // console.log(file,filename);

    // const formData = new FormData()
    // formData.append(
    //   'Image',e.target.files[0],e.target.files[0].name
    // )
      // console.log(file,formData)

    setLocation({
      // ...location,
      id:valuesf ? valuesf.id : '0',
      Image: e.target.files[0],
      Filename: e.target.files[0].name,
    });

    setValuesf({
      ...valuesf,
      img: e.target.files[0].name
    })

    // const photoURL = URL.createObjectURL(file);

      // console.log(valuesf)

  };

  const handleUploadFile = async () =>  {
    // e.preventDefault();
    // console.log("handleUploadfile",location)
    // console.log(file,valuesf.id)
    setUploading(true);
    const fd = new FormData();
    fd.append("mode", "product");
    fd.append("id", valuesf.id);
    fd.append("name", valuesf.name);
    fd.append("image", file);

        try {

          setTimeout( async () => {
              const result1 = await axios.post(`${apiurl}/upload.php`,fd)
              // const result1 = await axios({
              //   method: 'post',
              //   url: `${process.env.REACT_APP_API}/upload.php`,
              //   headers: {
              //       'Accept': 'application/json',
              //       // 'Content-type': 'application/x-www-form-urlencoded',
              //       // 'Content-type': 'application/json; charset=utf-8',
              //       'Content-Type': 'multipart/form-data'
              //   },
              //   // data: JSON.stringify(fd) ,
              //   data: fd,
              // });
              console.log(result1.data);
              if(result1.data.message==="Update Success.") {
                setErrMsg({type:'info', info:"file has been uploaded."});
              // if (result1.data && result1.status===200) {
              //   const ava = result1.data.userAvatar
              //   setFilename(ava)
              //   // enqueueSnackbar('Upload  success', {variant:'success'});
              //   // console.log(valuesf.userAvatar)
                  // setFile(null);
                  // setFilename(null);
                  setUploading(false);
                // const updateUser = {id: valuesf.id, Avatar: valuesf.Avatar };
                // const result = await axios.put(`${apiurl}/users.php?mode=updateAvatar`,updateUser)
                // const result2 = await  fetchData(
                //                     {
                //                       url: `${apiurl}/ActUsers/edituser/${valuesf.id}`,
                //                       method: 'PUT',
                //                       body: updateUser,
                //                     },
                //                     dispatch
                //                   );
                // console.log(result)
                // if (result.ok) {
                  // setUploading(false)
              //     setLocation(
              //       { id: '', Image: '', Filename: '' }
              //     )
              //     // enqueueSnackbar('Update data success', {variant:'success'});
              //   } else
              //   {
              //     setUploading(false)
              //     // enqueueSnackbar('!!!Update data Error !!!', {variant:'error'});
              //   }
              //   setErrMsg("User Avatar uploaded.")
              // } else {
              //   setErrMsg(result.data);
              // }
            
              } else {
                setErrMsg({type:'err', info:result1.data});
              }

            }, 1500);

            } catch (error) {
                // enqueueSnackbar('!!!Upload Error !!!', {variant:'error'});
                setUploading(false)
              console.log(error)
              setErrMsg({type:'err', info:'!!!Upload Error !!!'});
            }

}

const handleCancel =  async (e) => {
  e.preventDefault();
  setLoading(false);
  setUploading(false);
  setSaveSuccess(false);
  setDataChenged(false);
  setValuesf(initValuesf);
}
  const handleSave =  async (e) => {
    e.preventDefault();
    setLoading(true);
    // encryptPwd()
   
    updateDB()
    
  }

  const updateDB = async () => {
    // console.log({...oths})
    // const fd = new FormData()
    // fd.append(valuesf)
    // const udata = {
    //               id: valuesf.id,
    //               email:valuesf.email,
    //               name:  valuesf.name,
    //               // password: pwd.current,
    //               // password:valuesf.password,
    //               // Avatar:  valuesf.Avatar,
    //               Role:  valuesf.Role,
    //               isAdmin: valuesf.isAdmin,
    //               actived:  valuesf.actived,
    //             }
    // const { password, Avatar, ...oth } = valuesf
    // const apiurl = `${Conf.web_api}:${Conf.web_api_port}${Conf.web_api_url}/ActUsers`
        // console.log(udata,valuesf)
        // console.log(pwd.current,{...oths})
        // let token = password;
        // if(chgpwd) {
        //   let p = valuesf.email.trim() + valuesf.password.trim();
        //         console.log(p);
        //   token = aesEncrypt(p);
        //   setValuesf({
        //     ...valuesf,
        //     password: token,
        //   });     
        // }

        const updateProduct = {...valuesf, mode: productid==='addnew' ? 'add':'update',  };
        // console.log(updateUser);
        try {

          setTimeout( async () => {
            const result = await axios({
              method: 'post',
              url: `${apiurl}/products.php`,
              headers: {
                  'Accept': 'application/json',
                  // 'Content-type': 'application/x-www-form-urlencoded',
                  // 'Content-type': 'application/json; charset=utf-8',
                  'Content-Type': 'multipart/form-data'
              },
              data: JSON.stringify(updateProduct) ,
            });

            // console.log(result)
            if (result.data[0]) {
              setLoading(false);
              setSaveSuccess(true);
              setDataChenged(false);
              setErrMsg({type:'info', info:"Success."});
              // enqueueSnackbar('Save success', {variant:'success'});  
              
              // if(file && userid && userid==='addnew')
              //     await handleUploadFile()

              if(productid && productid==='addnew'){
                setValuesf(initValuesf);
              }

            } else
            {
              // setValuesf({
              //   ...valuesf,
              //   userPwd: '',
                
              // });    
              console.log(result);
              setLoading(false);
              setSaveSuccess(false);
              setErrMsg({type:'err', info:'!!! Save Error !!!'});
              // enqueueSnackbar('!!!Save Error !!!', {variant:'error'});
            }

         }, 1500);
        
        } 
        catch (error) {
          // setValuesf({
          //       ...valuesf,
          //       userPwd: '',
          //     });    
          // enqueueSnackbar('!!! Critical Error !!!', {variant:'error'});
            setErrMsg({type:'err', info:'!!! Critical Error !!!'});
            setLoading(false);
            setSaveSuccess(false);
            console.log(error);

           // console.log('handleSave')
         };

  }

    // const handleClickShowPassword = () => {
      // setValuesf({
      //   ...valuesf,
      //   showPassword: !valuesf.showPassword,
      // });
  
      // setShowPassword(!showPassword)
  
      // console.log('handleClickShowPassword')
    // };
  
    // const handleMouseDownPassword = (event) => {
    //   event.preventDefault();
    //   // console.log('handleMouseDownPassword')
    // };
  
    // const handleClickChgPassword = (e) => {
    //   e.preventDefault();
    //   // setValuesf({...valuesf, password:''});
    //   setAsd(false)
  
    //   setShowPassword(true)
    //   if(userid && userid!=='addnew') 
    //     setChgpwd(true)
    //   else
    //     setChgpwd(false)
    //   // console.log('handleClickChgPassword')
    // };
    // const encryptPwd = ()=> {
    //   // e.preventDefault();
    //   // const encryptTxt = enCrypt(valuesf.userPwd)
    //   if(valuesf.userPwd.trim()!==''&& asd===false ){
    //     let p = valuesf.email + valuesf.password;
    //           // console.log(p);
    //     const token = aesEncrypt(p);
    //     setValuesf({
    //       ...valuesf,
    //       password: token,
    //     });  
    //     setAsd(true)
    //   }

    //   if(loading) updateDB()
    
    //   if(saveloading) updatePwd()


    // }


    
    
    // const handleSavePassword =  (e) => {
    //   e.preventDefault();
    //   setSaveLoading(true)
    //   setShowPassword(false)
    //   encryptPwd()
    //   updatePwd()
    // }
  
    // const updatePwd =  () => {
  
    //   const updateUserPwd = {id: valuesf.id, password: valuesf.password };
    //     console.log(updateUserPwd)
    //       try {

    //         setTimeout( async () => {
    //           // const result = await changeUserPwd(updateUser, valuesf.id, dispatch);
    //           const result = await  axios(
    //                                   {
    //                                     url: `${apiurl}/users.php?mode=update&id=${valuesf.id}`,
    //                                     method: 'PUT',
    //                                     body: updateUserPwd,
    //                                   },
    //                                   // dispatch
    //                                 );
    //           // console.log(result)
    //           if (result.ok) {
    //             setChgpwd(!chgpwd)
    //             setSaveLoading(false)
    //             // enqueueSnackbar('Save success', {variant:'success'});
    //           } else
    //           {
    //             setChgpwd(!chgpwd)
    //             setSaveLoading(false)
    //             // enqueueSnackbar('!!!Save Error !!!', {variant:'error'});
    //           }

    //         }, 1500);

    //       }
    //       catch (error) {
    //           // enqueueSnackbar('!!!Save Error !!!', {variant:'error'});
    //           setSaveLoading(false)
    //           console.log(error)
    //         }
  
    //   // console.log('handleSavePassword')
    // }
  



  const  handleFormChange = (prop) => async (event) => {
    // console.log(prop,event.target.innerText)
    // if(prop==='category') {
    //   await setValuesf({ ...valuesf, [prop]: event.target.innerText });
    // } else if(prop==='password') {
    //   setChgpwd(true);
    //   await setValuesf({ ...valuesf, [prop]: event.target.value });
    // } else {
    if(prop==='active' || prop==='promote' || prop==='recommend') {
      await setValuesf({ ...valuesf, [prop]: event.target.checked });
    } else {
      await  setValuesf({ ...valuesf, [prop]: event.target.value });
    }

    // if(prop==='userName') {
    //   setValuesf({ ...initValuesf, uuser: valuesf.uuser, cuser: valuesf.uuser})
    //   console.log('updated')
    // }


    setDataChenged(true);
    setSaveSuccess(false);

    // setValuesf({uuser: currentUser.uuser, udate: curDate });
        
    // if(prop!=='userPwd') 
    //   setSuccess(false)
    // }

    // console.log('handleFormChange',valuesf,initValuesf)
  };

  //====================== end handle ============

  // useEffect(() => {

  //   if(valuesf.password==='') {
  //     setAsd(false)
  //   }

  //   pwd.current = valuesf.password;
  //   // setErrMsg(pwd.current)
  //   // console.log(valuesf.userPwd)


  // }, [valuesf,asd]);

  const Category = [
    {
      value: 1,
      label: 'Bakery',
    },
    {
      value: 2,
      label: 'Chiffon',
    },
    {
      value: 3,
      label: 'Cake',
    },
    {
      value: 4,
      label: 'Oth',
    },
    {
      value: 5,
      label: 'ชิฟฟ่อน',
    },
    {
      value: 6,
      label: 'เค้ก',
    },
    {
      value: 7,
      label: 'ขนมปัง',
    },
    {
      value: 8,
      label: 'ทั่วไป',
    },
    {
      value: 9,
      label: 'วุ้น',
    },
    {
      value: 10,
      label: 'วัฟเฟอร์',
    },
  ];

// console.log(valuesf);

  return (
    <div className="flex flex-col justify-center mx-auto pt-6 items-center w-full max-w-xl">
      {/* {!user.isLogin && navigate("/")} */}
      <div className="w-full">
      <Box className="flex p-1 justify-between ">
        <Typography variant="h6" component="h6" className="flex p-1 items-center" >
            { productid ==="addnew" ? "Add new" :  `Edit Product : ${productid}` }
        </Typography>
        { user.user?.isAdmin >=1 && 
                <Typography variant="h6" component="h6" p={2} >
          <Link to="/products" className="p-1 border border-gray-500 rounded-md hover:text-sky-500">
             Back to List 
          </Link>
        </Typography>
        }
      </Box>  </div>

      <div className="m-auto mt-2 p-2 w-full justify-center items-center">
        <h2 className="text-base/7 font-semibold text-gray-300">Products Information</h2>

        <div className="col-span-full">
          {/* <label htmlFor="photo" className="block text-sm/6 font-medium text-gray-900">
            Photo
          </label> */}
          <div className="mt-2 px-4 flex items-center justify-end gap-x-3">
            {/* <UserCircleIcon aria-hidden="true" className="size-12 text-gray-300" /> */}
            <img 
              alt="Avatar"
              className="object-cover h-28 w-48 border"
              src={ 
                    file
                    ? URL.createObjectURL(file)
                    : !productid || productid==='addnew'
                    ? undefined
                    : `${imgurl}/image/products/${valuesf.img}`
                  } 
                // style={{ cursor: "pointer" }}
            />  
            <label htmlFor="Avatar" className="block text-sm/6 font-medium text-gray-300">

              {/* <button
                type="button"
                className="flex w-full justify-center text-center rounded-md bg-white px-2.5 py-1.5 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50"
              > */}
              <button
                type="submit" 
                disabled={productid!=='addnew' && file? false : true}
                className={productid!=='addnew' && filename? "rounded-md bg-cyan-700  px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-cyan-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600" : "rounded-md bg-slate-800 px-3 py-2 text-sm font-semibold"}
                onClick={handleUploadFile}
              > 
                <Tooltip title="Upload File...">
                      <CloudUploadIcon />
                </Tooltip>
              </button>
              <label htmlFor="folder" className="flex justify-end ">
                  (SizeLimit: 500kb) Change
                <Tooltip title="Browse File...">
                  <FolderSharedIcon  className={productid!=='addnew' ? "ml-2 hover:cursor-pointer hover:text-amber-400" : "ml-2" } />
                </Tooltip>
                <input
                    type="file"
                    id="folder"
                    onChange={onChangeFile}
                    disabled={productid==='addnew' ? true : false}
                    // onChange={(e) => setFile(e.target.files[0])}
                    style={{ display: "none"}}
                />
              </label>
                {/* </button> */}


                <input
                  id="img"
                  name="img"
                  color="secondary"
                  type="text"
                  disabled
                  value={valuesf.img}
                  className="flex w-full text-center rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:text-sm/6"
                />
              </label>
          </div>
          
        </div>

          <div className="mt-2 grid grid-cols-1 md:grid-cols-2 md:gap-2 max-w-lg">
            <div className="col-span-1">
              <label htmlFor="name" className="block text-sm/6 font-medium text-gray-300">
                Name
              </label>
              <div className="mt-2 grid grid-cols-1">
                <input
                  id="name"
                  name="name"
                  value={valuesf.name}
                  onChange={handleFormChange('name')}
                  autoComplete="given-name"
                  type="text"
                  className="block sm:w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:text-sm/6"
                />
              </div>
            </div>

            <div className="col-span-1">
              <label htmlFor="description" className="block text-sm/6 font-medium text-gray-300">
                Description
              </label>
              <div className="mt-2 grid grid-cols-1">
                <textarea
                  id="description"
                  name="description"
                  value={valuesf.description}
                  onChange={handleFormChange('description')}
                  autoComplete="given-description"
                  type="text"
                  className="block sm:w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:text-sm/6"
                />
              </div>
            </div>

            <div className="mt-2 grid grid-cols-1">
              {/* <label htmlFor="category" className="block text-sm/6 font-medium text-gray-300">
                Category
              </label> */}
              {/* <div className="mt-2 grid grid-cols-1"> */}
              <Autocomplete
                id="category"
                name="category"
                freeSolo
                size="small"
                selectOnFocus
                clearOnBlur
                handleHomeEndKeys
                value={valuesf.category}
                // onChange={handleFormChange('category')}
                inputValue={valuesf.category}
                onInputChange={(event, newInputValue) => {
                  setValuesf({ ...valuesf, category: newInputValue });
                  setDataChenged(true);
                }}
                options={category?.map((option) => option.category)}
                renderInput={(params) => <TextField {...params} label="category" />}
              
                className="col-start-1 row-start-1 sm:w-full appearance-none rounded-md bg-white py-2 px-1  text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:text-sm/6"
              />
                {/* <select
                  id="category"
                  name="category"
                  value={valuesf.category}
                  onChange={handleFormChange('category')}
                  autoComplete="category"
                  className="col-start-1 row-start-1 sm:w-full appearance-none rounded-md bg-white py-1.5 pl-3 pr-8 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:text-sm/6"
                >
                  {category?.map((cat,i) => (
                   <option key={i}>{cat.category}</option>

                  ))}
                </select>
                <ChevronDownIcon
                  aria-hidden="true"
                  className="pointer-events-none col-start-1 row-start-1 mr-2 size-5 self-center justify-self-end text-gray-500 sm:size-4"
                /> */}
              {/* </div> */}
            </div>
            <div className="col-span-1">
              <label htmlFor="price" className="block text-sm/6 font-medium text-gray-300">
                Price
              </label>
              <div className="mt-2 grid grid-cols-1">
                <input
                  id="price"
                  name="price"
                  value={valuesf.price}
                  onChange={handleFormChange('price')}
                  autoComplete="given-price"
                  type="number"
                  className="block sm:w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:text-sm/6"
                />
              </div>
            </div>
            <div className="col-span-1">
              <label htmlFor="instock" className="block text-sm/6 font-medium text-gray-300">
                inStock
              </label>
              <div className="mt-2 grid grid-cols-1">
                <input
                  id="instock"
                  name="instock"
                  disabled={productid!=='addnew' ? true : false}
                  value={valuesf.instock}
                  onChange={handleFormChange('instock')}
                  autoComplete="given-instock"
                  type="number"
                  className={productid!=='addnew' ? "block sm:w-full rounded-md px-3 bg-slate-500" : "block sm:w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:text-sm/6"}
                />
              </div>
            </div>
            <div className="mt-2 grid grid-cols-3 gap-6">
                <label>
                    Recommend: 
                    <input 
                      id="recommend"
                      name="recommend"
                      checked={valuesf.recommend==1? true:false} 
                      onChange={handleFormChange('recommend')} 
                      type="checkbox"
                      className="inline-block ml-4"
                    />
                </label>
                <label>
                    Promote: 
                    <input 
                      id="promote"
                      name="promote"
                      checked={valuesf.promote==1? true:false} 
                      onChange={handleFormChange('promote')} 
                      type="checkbox"
                      className="inline-block ml-4"
                    />
                </label>
                <label>
                    Active: 
                    <input 
                      id="active"
                      name="active"
                      checked={valuesf.active==1? true:false} 
                      onChange={handleFormChange('active')} 
                      type="checkbox"
                      className="inline-block ml-4"
                    />
                </label>
              </div>
          </div>

          <div className="mt-6 flex items-center justify-between gap-x-6 border-t-2 py-2">
            <div>
              <button 
                  type="button" 
                  disabled={user.user?.isAdmin==1? false : true}
                  className={user.user?.isAdmin==1? "rounded-md bg-teal-800  px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-teal-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600" : "rounded-md bg-slate-800 px-3 py-2 text-sm font-semibold"}
                  onClick={handleAddnew}
                  >
                  Add New
              </button>
            </div>
            <div className="flex gap-4">
              <button 
                type="button" 
                disabled={!dataChenged}
                className={dataChenged? "rounded-md bg-red-800  px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-red-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600" : "rounded-md bg-slate-800 px-3 py-2 text-sm font-semibold"}
                onClick={handleCancel}
                >
                Cancel
              </button>
              <button
                type="submit"
                disabled={!dataChenged}
                className={dataChenged? "rounded-md bg-indigo-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600" :"rounded-md bg-slate-800 px-3 py-2 text-sm font-semibold"}
                onClick={handleSave}
              >
                Save
              </button>
            </div>
          </div>
          {/* <MessInfo mess={errMsg} /> */}
          <p className={errMsg.type==='err'? "text-red-600" : "text-green-600"}>
            {errMsg.info}
          </p>
        </div>


      
    </div>

  )
}

export default ProductDetail